import styled from 'styled-components';

/* Text rendered within this span will be accessible
 * to screen readers for visually impaired users but
 * not visible on the webpage in browsers.
 */

const OffscreenText = styled.span`
    border: 0;
    clip: rect(0 0 0 0);
    contain: paint;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
`;

export { OffscreenText as default, OffscreenText };
